import "./zaim.scss";

import { useState, useEffect } from "react";

import OneZaim from "./oneZaim/oneZaim";
import Checkbox from "../checkbox/checkbox";
import FilterBtn from "./filterBtn";

import error404 from "../credit/404.jpg";
import loadingsvg from "../credit/loading.svg";
import turboImg from "./oneZaim/img/turbo_ru_fon.png";
import joyImg from "./oneZaim/img/joymoney_ru_fon.png";
import webZaim from "./oneZaim/img/web-zaim_ru_fon.png";
import webBankirImg from "./oneZaim/img/webbankir_ru_fon.png";
import zaimerImg from "./oneZaim/img/zaimer_ru_fon.png";

const btnsFilter = [
  {
    text: "На карту",
    type: "card",
  },
  {
    text: "Круглосуточно",
    type: "allDay",
  },
  {
    text: "Без отказа",
    type: "withoutReject",
  },
  {
    text: "Под залог ПТС",
    type: "withDeposit",
  },
  {
    text: "Первый без процентов",
    type: "withoutPercents",
  },
  {
    text: "На пол года",
    type: "longTimeLoan",
  },
];
const typesBtnsFilters = {
  card: "Займы на карту",
  allDay: "Займ на карту круглосуточно",
  withoutReject: "Займ на карту без отказа",
  withDeposit: "Займы под залог",
  longTimeLoan: "Долгосрочные займы",
  withoutPercents: "Займ без процентов",
};
// Срочно деньги, турбо займ, Boostra, Займер, Быстроденьги,
// ВебЗайм, Webbankir, CreditPlus, JoyMoney, E-заем
const RIGHT_LOANS = {
  10523: true,
  Turbozaim_loan_1044: true,
  Boostra_loan_240: true,
  Zaymer_loan_530: true,
  8833: true,
  WebZaim_loan_1051: true,
  Webbankir_loan_522: true,
  750: true,
  id_10387: true,
  Ezaem_loan_718: true,
};
const RIGHT_LOANS_ADDITIONAL = {
  10523: {
    order:
      "https://pxl.leads.su/click/afa46031297a1cef39d45a9d241d8c1d?aff_sub1=zaim&erid=2W5zFJkUBEY",
    successLoan: "Высокое",
    stars: "4.8",
    daysLoan: "180 дней",
    summMax: "100 000",
    ytp: "Первый займ 0%",
  },
  Turbozaim_loan_1044: {
    order:
      "https://pxl.leads.su/click/548a438820f1aca5d2165a55b9a666a2?aff_sub1=zaim&erid=2W5zFHKRY8p",
    successLoan: "Высокое",
    stars: "4.9",
    summMax: "100 000",
    daysLoan: "168 дней",
    ytp: "Первый займ 0%",
    screen: turboImg,
  },
  Boostra_loan_240: {
    order:
      "https://pxl.leads.su/click/59eb1ad284ec7bc8029fb67828012488?aff_sub1=zaim&erid=2W5zFHLrpVv",
    successLoan: "Высокое",
    stars: "4.6",
    summMax: "30 000",
    daysLoan: "30 дней",
    ytp: "Первый займ 0%",
  },
  Zaymer_loan_530: {
    order:
      "https://pxl.leads.su/click/a4a04f5b27f69a1ab26294b9bb0c7841?aff_sub1=zaim&erid=2W5zFHXAP3n",
    successLoan: "Высокое",
    stars: "4.5",
    summMax: "30 000",
    daysLoan: "30 дней",
    ytp: "Первый займ 0%",
    screen: zaimerImg,
    name: "Займер VIP",
  },
  8833: {
    order:
      "https://pxl.leads.su/click/b3923f5d84bc9b65d71012fff8acda90?aff_sub1=zaim&erid=2W5zFJNSUBS",
    successLoan: "Высокое",
    stars: "4.7",
    summMax: "15 000",
    daysLoan: "30 дней",
    ytp: "Первый займ 0%",
  },
  WebZaim_loan_1051: {
    order:
      "https://pxl.leads.su/click/fba468eee6476d2f2fa63c72bf9e4f6a?aff_sub1=zaim&erid=2W5zFGjNpAL",
    successLoan: "Высокое",
    stars: "4.8",
    summMax: "30 000",
    daysLoan: "30 дней",
    ytp: "Первый займ 0%",
    screen: webZaim,
  },
  Webbankir_loan_522: {
    order:
      "https://pxl.leads.su/click/3b7f0010035ed3720c9cc146eef011ad?aff_sub1=zaim&erid=2W5zFFz557e",
    successLoan: "Высокое",
    stars: "4.5",
    summMax: "30 000",
    daysLoan: "30 дней",
    ytp: "Первый займ 0%",
    screen: webBankirImg,
  },
  750: {
    order:
      "https://pxl.leads.su/click/d6241c601e04c14b9b4fb0afc41d29aa?aff_sub1=zaim&erid=2W5zFJvsS8g",
    successLoan: "Высокое",
    stars: "4.7",
    summMax: "30 000",
    daysLoan: "20 дней",
    ytp: "С любой КИ",
  },
  id_10387: {
    order:
      "https://pxl.leads.su/click/48a80b01f2df80ece62fd87ffa7c8407?aff_sub1=zaim&erid=2W5zFGxo4xY",
    successLoan: "Высокое",
    stars: "4.6",
    summMax: "100 000",
    daysLoan: "168 дней",
    ytp: "Первый займ 0%",
    screen: joyImg,
  },
  // Ezaem_loan_718: {
  //   order:
  //     "https://pxl.leads.su/click/851faf486c06bb55bc9092bc4ea295fa?erid=2W5zFG6BRnp",
  //   successLoan: "Высокое",
  //   stars: "4.4",
  //   summMax: "30 000",
  //   daysLoan: "35 дней",
  //   ytp: "Первый займ 0%",
  // },
};

const Zaim = () => {
  const isMobile = window.screen.width > 992 ? false : true;
  const [originalData, setOriginalData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortOpen, setSortOpen] = useState(false);
  const [isFiltersMobileOpen, setFiltersMobileOpen] = useState(false);
  const [sortType, setSortType] = useState("Сортировать");
  const [btnFiltersType, setBtnFiltersType] = useState([]);

  const [amount, setAmount] = useState("");
  const [percent, setPercent] = useState("");
  const [days, setDays] = useState("");

  const [selectedOptions, setSelectedOptions] = useState({
    mastercard: false,
    mir: false,
    visa: false,
    qiwi: false,
    yandex: false,
    cash: false,
  });

  useEffect(() => {
    fetch("https://comandosfru.xyz/adsfin/db.json")
      .then((response) => {
        if (!response.ok)
          throw new Error("Network response was not ok " + response.statusText);
        return response.json();
      })
      .then((data) => {
        const response = data.loans.reduce((acc, item) => {
          RIGHT_LOANS[item.itemId] &&
            acc.push({
              ...item,
              ...RIGHT_LOANS_ADDITIONAL[item.itemId],
            });
          return acc;
        }, []);

        setOriginalData(response);
        setFilteredData(response);
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  }, []);

  const formatNumber = (value) => {
    const sanitizedValue = value.replace(/\D/g, "");
    return sanitizedValue.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };

  const handleAmountChange = (e) => {
    const formattedValue = formatNumber(e.target.value);
    setAmount(formattedValue);
  };
  const handlePercentChange = (e) => {
    let value = e.target.value;
    if (value.includes(",")) {
      value = value.replace(",", ".");
    }
    setPercent(value);
  };
  const handleDaysChange = (e) => {
    let value = e.target.value;
    if (value.includes(",")) {
      value = value.replace(",", ".");
    }
    setDays(value);
  };

  const handleSearch = () => {
    const filtered = originalData.filter((zaim) => {
      const amountNum = parseFloat(amount.replace(/\s/g, ""));
      const percentNum = parseFloat(percent.replace(",", "."));
      const daysNum = parseFloat(days.replace(",", "."));

      const minSum = parseFloat(zaim.summMin.replace(/\s/g, ""));
      const maxSum = parseFloat(zaim.summMax.replace(/\s/g, ""));

      const amountCondition =
        isNaN(amountNum) || (minSum <= amountNum && maxSum >= amountNum);
      const percentCondition =
        isNaN(percentNum) ||
        parseFloat(zaim.percent.replace(",", ".") * 100) >= percentNum;

      const daysCondition = isNaN(daysNum) || zaim.daysLoan >= daysNum;

      return amountCondition && percentCondition && daysCondition;
    });

    const isAnyCheckboxChecked = Object.values(selectedOptions).some(
      (option) => option
    );

    const finalFiltered = isAnyCheckboxChecked
      ? filtered.filter((item) => {
          return (
            (selectedOptions.mastercard && item.show_mastercard === "1") ||
            (selectedOptions.mir && item.show_mir === "1") ||
            (selectedOptions.visa && item.show_visa === "1") ||
            (selectedOptions.qiwi && item.show_qiwi === "1") ||
            (selectedOptions.yandex && item.show_yandex === "1") ||
            (selectedOptions.cash && item.show_cash === "1")
          );
        })
      : filtered;

    setFilteredData(finalFiltered);
    sortData(sortType, finalFiltered);
  };

  const toggleSortDropdown = () => setSortOpen(!sortOpen);

  const sortData = (type, data) => {
    let sortedData = [...data];

    if (type === "Сумма по возрастанию") {
      sortedData.sort(
        (a, b) =>
          parseFloat(a.summMax.replace(/\s/g, "")) -
          parseFloat(b.summMax.replace(/\s/g, ""))
      );
    } else if (type === "Сумма по убыванию") {
      sortedData.sort(
        (a, b) =>
          parseFloat(b.summMax.replace(/\s/g, "")) -
          parseFloat(a.summMax.replace(/\s/g, ""))
      );
    } else if (type === "Проценты по возрастанию") {
      sortedData.sort(
        (a, b) =>
          parseFloat(a.percent.replace(",", ".")) -
          parseFloat(b.percent.replace(",", "."))
      );
    } else if (type === "Проценты по убыванию") {
      sortedData.sort(
        (a, b) =>
          parseFloat(b.percent.replace(",", ".")) -
          parseFloat(a.percent.replace(",", "."))
      );
    }

    setFilteredData(sortedData);
  };

  const handleFilterChange = (options) => {
    setSelectedOptions(options);
    applyFilters(options, amount, percent);
  };

  const handleSort = (type) => {
    setSortType(type);
    sortData(type, filteredData);
    setSortOpen(false);
  };

  const applyFilters = (options, amountValue, percentValue) => {
    const amountNum = parseFloat(amountValue.replace(/\s/g, ""));
    const percentNum = parseFloat(percentValue.replace(",", "."));

    const filtered = originalData.filter((item) => {
      const isChecked =
        (options.mastercard && item.show_mastercard === "1") ||
        (options.mir && item.show_mir === "1") ||
        (options.visa && item.show_visa === "1") ||
        (options.qiwi && item.show_qiwi === "1") ||
        (options.yandex && item.show_yandex === "1") ||
        (options.cash && item.show_cash === "1");

      const minSum = parseFloat(item.summMin.replace(/\s/g, ""));
      const maxSum = parseFloat(item.summMax.replace(/\s/g, ""));

      const amountCondition =
        isNaN(amountNum) || (minSum <= amountNum && maxSum >= amountNum);
      const percentCondition =
        isNaN(percentNum) ||
        parseFloat(item.percent.replace(",", ".")) <= percentNum;

      return (
        (isChecked || Object.values(options).every((opt) => !opt)) &&
        amountCondition &&
        percentCondition
      );
    });

    setFilteredData(filtered);
  };

  const filterByBtns = ({ filters }) => {
    setFilteredData((prev) =>
      filters.length
        ? prev.filter(({ tags }) =>
            filters.some((filter) =>
              JSON.parse(tags).includes(typesBtnsFilters[filter])
            )
          )
        : originalData
    );
  };
  if (loading)
    return <img src={loadingsvg} alt="Loading" style={{ margin: "0 auto" }} />;
  if (error)
    return (
      <img
        src={error404}
        alt=""
        style={{ margin: "0 auto", maxWidth: "100%" }}
      />
    );

  return (
    <div className="zaim">
      {!isMobile && (
        <Checkbox
          selectedOptions={selectedOptions}
          onFilterChange={handleFilterChange}
        />
      )}
      <div className="container">
        <div className="zaim__wrapper">
          <h2 className="user">Выбор пользователей:</h2>
          <div className="zaim__wrapper-buttons">
            {btnsFilter.map(({ text, type }) => {
              return (
                <FilterBtn
                  text={text}
                  filterType={type}
                  allFilters={btnFiltersType}
                  handleClick={({ filterType }) =>
                    setBtnFiltersType((prevFilters) => {
                      const updatedFilters = prevFilters.includes(filterType)
                        ? prevFilters.filter((filter) => filter !== filterType)
                        : [...prevFilters, filterType];

                      filterByBtns({ filters: updatedFilters });
                      return updatedFilters;
                    })
                  }
                />
              );
            })}
          </div>
          {!isMobile ? (
            <div className="zaim__wrapper-inputs">
              <input
                type="text"
                placeholder="Укажите сумму:"
                value={amount}
                onChange={handleAmountChange}
              />
              <input
                type="text"
                placeholder="Укажите срок займа:"
                value={days}
                onChange={handleDaysChange}
              />
              <input
                type="text"
                placeholder="Укажите проценты:"
                value={percent}
                onChange={handlePercentChange}
              />
              <button onClick={handleSearch}>Подобрать займ</button>
            </div>
          ) : (
            <div className="zaim__btns">
              <button
                className="zaim__open-filters"
                onClick={() => setFiltersMobileOpen((prev) => !prev)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  >
                    <ellipse cx="12" cy="5" rx="9" ry="2"></ellipse>
                    <path d="M3 5c0 2.23 3.871 6.674 5.856 8.805A4.197 4.197 0 0 1 10 16.657V19a2 2 0 0 0 2 2v0a2 2 0 0 0 2-2v-2.343c0-1.061.421-2.075 1.144-2.852C17.13 11.674 21 7.231 21 5"></path>
                  </g>
                </svg>
                Фильтры
              </button>
              {isFiltersMobileOpen && (
                <div className="zaim__filters-mobile">
                  <header className="zaim__header">
                    <h2>Фильтры</h2>
                    <button onClick={() => setFiltersMobileOpen(false)}>
                      ×
                    </button>
                  </header>
                  <Checkbox
                    selectedOptions={selectedOptions}
                    onFilterChange={handleFilterChange}
                  />
                  <div className="zaim__wrapper-inputs">
                    <input
                      type="text"
                      placeholder="Укажите сумму:"
                      value={amount}
                      onChange={handleAmountChange}
                    />
                    <input type="text" placeholder="Укажите срок займа:" />
                    <input
                      type="text"
                      placeholder="Укажите проценты:"
                      value={percent}
                      onChange={handlePercentChange}
                    />
                    <button
                      onClick={() => {
                        setFiltersMobileOpen(false);
                        handleSearch();
                      }}
                    >
                      Подобрать займ
                    </button>
                  </div>
                </div>
              )}
              <div className="dropdown">
                <button onClick={toggleSortDropdown} className="sort-button">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="#ffffff"
                      d="M13.47 7.53a.75.75 0 0 0 1.06 0l.72-.72V17a.75.75 0 0 0 1.5 0V6.81l.72.72a.75.75 0 1 0 1.06-1.06l-2-2a.75.75 0 0 0-1.06 0l-2 2a.75.75 0 0 0 0 1.06m-4.72 9.66l.72-.72a.75.75 0 1 1 1.06 1.06l-2 2a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 1 1 1.06-1.06l.72.72V7a.75.75 0 0 1 1.5 0z"
                    ></path>
                  </svg>
                  {sortType}
                </button>
                {sortOpen && (
                  <div className="dropdown-menu">
                    <button onClick={() => handleSort("Сумма по возрастанию")}>
                      Сумма по возрастанию
                    </button>
                    <button onClick={() => handleSort("Сумма по убыванию")}>
                      Сумма по убыванию
                    </button>
                    <button
                      onClick={() => handleSort("Проценты по возрастанию")}
                    >
                      Проценты по возрастанию
                    </button>
                    <button onClick={() => handleSort("Проценты по убыванию")}>
                      Проценты по убыванию
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}

          <div className="sort-container">
            {isMobile ? (
              <>
                <h1>Займы Онлайн</h1>
                <h2>
                  Оформите лучшие займы до 100.000 руб. на карту не выходя из
                  дома
                </h2>
              </>
            ) : (
              <>
                <h1>Найдено {filteredData.length} предложений</h1>
                <div className="dropdown">
                  <button onClick={toggleSortDropdown} className="sort-button">
                    {sortType}
                  </button>
                  {sortOpen && (
                    <div className="dropdown-menu">
                      <button
                        onClick={() => handleSort("Сумма по возрастанию")}
                      >
                        Сумма по возрастанию
                      </button>
                      <button onClick={() => handleSort("Сумма по убыванию")}>
                        Сумма по убыванию
                      </button>
                      <button
                        onClick={() => handleSort("Проценты по возрастанию")}
                      >
                        Проценты по возрастанию
                      </button>
                      <button
                        onClick={() => handleSort("Проценты по убыванию")}
                      >
                        Проценты по убыванию
                      </button>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
          <div className="zaim__zaims">
            {filteredData.map((dat) => (
              <OneZaim key={dat.id} dat={dat} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Zaim;
